<div class="criteria-header">
  <ng-container *ngIf="criterio.nombre !==''">
    <label>{{criterio.nombre}}</label>
  </ng-container>
  <mat-chip class="glm-chip goal-chip" [matTooltip]="criterio.metaData.id">{{criterio.metaData.desc}}</mat-chip>
</div>
<!-- TODO: CAMBIAR id si toca -->
<app-autoevaluacion-criterio-group
  [autoevaluacion$]="autoevaluacion$"
  [autoevaluacion]="autoevaluacion"
  [alumnoId]="autoevaluacion.id"
  [unidadEventoMateriaId]="autoevaluacion.unidadEventoMateriaId"
  [nivel]="criterio.niveles[nivel]"></app-autoevaluacion-criterio-group>
